/** @jsxImportSource @emotion/react */
import { APP_NAME } from 'configs/AppConfig'
import { css } from '@emotion/react'
import {
  TEMPLATE,
  MEDIA_QUERIES,
  DARK_MODE,
  BORDER,
} from 'constants/ThemeConstant'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  DiscordOutlined,
  InstagramOutlined,
  MailOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'

export default function Footer() {
  const currentTheme = useSelector(state => state.theme.currentTheme)

  return (
    <footer
      css={css`
        display: flex;
        padding: 1.5em 0;
        margin: 0 ${TEMPLATE.LAYOUT_CONTENT_GUTTER}px;
        align-items: center;
        border-top: 1px solid
          ${currentTheme === 'dark'
            ? DARK_MODE.BORDER_BASE_COLOR
            : BORDER.BASE_COLOR};
        justify-content: space-between;

        @media ${MEDIA_QUERIES.MOBILE} {
          justify-content: center;
          flex-direction: column;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 0.2em;
        `}
      >
        <span>
          &copy; {`${new Date().getFullYear()}`}{' '}
          <span className="font-weight-semibold">{`${APP_NAME}`}</span>. Todos
          os direitos reservados.
        </span>
        <span>CNPJ 52.023.098/0001-04</span>
      </div>

      <div>
        <Link className="text-body mr-2" to="https://docs.onepanel.com.br">
          Documentação
        </Link>
        <Link className="text-body" to="https://onepanel.com.br/termos">
          Termos & Condições
        </Link>

        {/* <span className='mx-2 text-muted'> | </span> */}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            justifyContent: 'center',
          }}
        >
          <Link
            className="text-body"
            to="mailto:contato@onepanel.com.br"
            style={{ fontSize: '32px' }}
          >
            <MailOutlined></MailOutlined>
          </Link>

          <Link
            className="text-body"
            to="https://www.instagram.com/onepanelcloud"
            style={{ fontSize: '32px' }}
          >
            <InstagramOutlined></InstagramOutlined>
          </Link>

          <Link
            className="text-body"
            to="https://discord.gg/pzXm7TgUbH"
            style={{ fontSize: '32px' }}
          >
            <DiscordOutlined></DiscordOutlined>
          </Link>

          <Link
            className="text-body"
            to="https://api.whatsapp.com/send?phone=21999957099&text=Ol%C3%A1,%20gostaria%20de%20saber%20mais%20sobre%20seus%20produtos"
            style={{ fontSize: '32px' }}
          >
            <WhatsAppOutlined></WhatsAppOutlined>
          </Link>
        </div>
      </div>
    </footer>
  )
}
